import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { DirectivesModule } from 'app/directives/directives.module';
import { CollaboratorSuggestComponent } from './components/collaborator-suggest/collaborator-suggest.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { CollaboratorChipsModule } from './components/collaborator-chips/collaborator-chips.module';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { InputDialogComponent } from './components/file-manager/input-dialog/input-dialog.component';
import { CommentsComponent } from './components/comments/comments.component';

import { MatRadioModule } from '@angular/material/radio';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EvaluatePipe } from './pipes/evaluate.pipe';
import { GetFromArrayByPipe } from './pipes/get-from-array-by.pipe';
import { ExistInPipe } from './pipes/exists-in.pipe';
import { KeyValueTranslatePipe } from './pipes/key-value-translate.pipe';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { SuggestInputComponent } from './components/suggest-input/suggest-input.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TreeSelectInputComponent } from './components/tree-select-input/tree-select-input.component';
import { MatTreeModule } from '@angular/material/tree';
import { OverlayModule } from '@angular/cdk/overlay';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule} from '@angular/material/card';
import {GuardedInputComponent} from './components/inputs/guarded-input/guarded-input.component';
import {TextInputComponent} from './components/inputs/text-input/text-input.component';
import {TextAreaInputComponent} from './components/inputs/text-area-input/text-area-input.component';
import {SelectInputComponent} from './components/inputs/select-input/select-input.component';
import {DateInputComponent} from './components/inputs/date-input/date-input.component';
import {SelectMultipleInputComponent} from './components/inputs/select-multiple-input/select-multiple-input.component';
import {RadioGroupComponent} from './components/inputs/radio-group-input/radio-group.component';
import {TextListInputComponent} from './components/inputs/text-list-input/text-list-input.component';
import {StatusSelectorComponent} from './components/inputs/status-selector-input/status-selector.component';
import {TableInputComponent} from './components/inputs/table-input/table-input.component';
import {FilesInputComponent} from './components/inputs/files-input/files-input.component';
import {TemplateInputComponent} from './components/inputs/template-input/template-input.component';
import {SimpleFileUploaderModule} from '../modules/simple-file-uploader/simple-file-uploader.module';
import { MatListModule } from '@angular/material/list';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { AlertActionsComponent } from './components/alert-actions/alert-actions.component';
import { MatStepperModule } from '@angular/material/stepper';
import {ComplaintChatComponent} from './components/complaint-chat.component.ts/complaint-chat.component';
import { AssignedTeamComponent } from './components/assigned-team/assigned-team.component';
import { AssociateAlertSharedComponent } from './components/associate-alert/associate-alert.component';
import { RequestOpenCaseComponent } from 'app/pages/cases/request-open-case/request-open-case.component';
import { SelectFollowUpActionsComponent } from 'app/pages/cases/select-follow-up-actions/select-follow-up-actions.component';
import { ConsultantsPanelComponent } from './components/consultants-panel/consultants-panel.component';
import { FollowupLogsComponent } from './components/followup-logs/followup-logs.component';
import { NotificationsPanelComponent } from './components/panels/notifications-panel/notifications-panel.component';
import { ReportsPanelComponent } from './components/panels/reports-panel/reports-panel.component';
import { MassiveActionsReportModalComponent } from './components/massive-actions-report/massive-actions-modal/massive-actions-modal.component';
import { StripedBarsCardComponent } from './components/loading-cards/cards/striped-bars-card/striped-bars-card.component';
import { NoDataCardComponent } from './components/loading-cards/cards/no-data-card/no-data-card.component';
import { FadingLoadingAnimationComponent } from './components/loading-cards/loading-animations/fading-loading-animation/fading-loading-animation.component';
import { FadeInAnimationComponent } from './components/loading-cards/loading-animations/fade-in-animation/fade-in-animation.component';
import { GeneralDataComponent } from 'app/pages/complaints/complaints-detail/tabs/general-data/general-data.component';
import { FileNavigationComponent } from './components/file-navigation/file-navigation.component';
import { PPFileDirectoryListComponent } from 'app/pages/pp-file-directory/pp-file-directory-list/pp-file-directory-list.component';
import { PPFileDirectoryModalComponent } from './components/pp-file-directory-actions/pp-file-directory-actions-modal/pp-file-directory-actions-modal.component';
import { FileVisorComponent } from './components/file-visor/file-visor.component';
import { ConfirmDisclaimerDialogComponent } from './components/confirm-disclaimer-dialog/confirm-disclaimer-dialog.component';
import { DateRangeComponent } from './components/inputs/date-range/date-range.component';
import { ChangeFoldernameDialogComponent } from './components/change-foldername-dialog/change-foldername-dialog.component';
import { InputsChipModalComponent } from './components/inputs-chip-modal/inputs-chip-modal.component';
import { ReportParametersDetailComponent } from './components/report-parameters-detail/report-parameters-detail.component';
import { ColumnOrderConfigComponent } from './components/column-order-config/column-order-config.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IgxAvatarModule } from 'igniteui-angular';
import { RoleUsersComponent } from './components/role-users/role-users.component';

const COMPONENTS = [
  BreadcrumbsComponent,
  CollaboratorSuggestComponent,
  FileManagerComponent,
  InputDialogComponent,
  CommentsComponent,
  GuardedInputComponent,
  DateInputComponent,
  SelectInputComponent,
  TextInputComponent,
  TextAreaInputComponent,
  SuggestInputComponent,
  TreeSelectInputComponent,
  SelectMultipleInputComponent,
  RadioGroupComponent,
  TextListInputComponent,
  StatusSelectorComponent,
  TableInputComponent,
  FilesInputComponent,
  TemplateInputComponent,
  DateRangeFilterComponent,
  RoleUsersComponent,
  AlertActionsComponent,
  AssignedTeamComponent,
  AssociateAlertSharedComponent,
  RequestOpenCaseComponent,
  SelectFollowUpActionsComponent,
  ConsultantsPanelComponent,
  FileNavigationComponent,

  /* Side Panel Components*/
  NotificationsPanelComponent,
  ReportsPanelComponent,
  StripedBarsCardComponent,
  NoDataCardComponent,
  FadingLoadingAnimationComponent,
  FadeInAnimationComponent,
  DateRangeComponent,
];

const PIPES = [
  EvaluatePipe,
  ExistInPipe,
  KeyValueTranslatePipe
];

const MODULES = [
  DirectivesModule,
  IgxAvatarModule,
  SimpleFileUploaderModule,
  ReactiveFormsModule,
  DragDropModule,
  // AlertSharedModule,
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    MatSidenavModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatListModule,
    MatDatepickerModule,
    MatChipsModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTreeModule,
    MatBadgeModule,
    CollaboratorChipsModule,
    FlexLayoutModule,
    OverlayModule,
    FuseSharedModule,
    MatProgressBarModule,
    MatCardModule,
    MatStepperModule,
    ...MODULES
  ],
  exports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSelectModule,
    MatSidenavModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatChipsModule,
    MatRadioModule,
    MatSlideToggleModule,
    CollaboratorChipsModule,
    OverlayModule,
    FuseSharedModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatCardModule,
    MatListModule,
    MatStepperModule,
    ...MODULES,
    ...COMPONENTS,
    ...PIPES,
    GetFromArrayByPipe,
    ComplaintChatComponent,
    FollowupLogsComponent,
    MassiveActionsReportModalComponent,
    GeneralDataComponent,
    PPFileDirectoryModalComponent
  ],
  declarations: [
    ...COMPONENTS,
    ...PIPES,
    GetFromArrayByPipe,
    ComplaintChatComponent,
    FollowupLogsComponent,
    MassiveActionsReportModalComponent,
    GeneralDataComponent,
    PPFileDirectoryModalComponent,
    FileVisorComponent,
    ConfirmDisclaimerDialogComponent,
    ChangeFoldernameDialogComponent,
    InputsChipModalComponent,
    ReportParametersDetailComponent,
    ColumnOrderConfigComponent,
    // DynamicFiltersComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' }
  ]
})
export class SharedModule {
}
